import { isNullOrUndefined } from '@uzurv/core';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DriverState } from './driver.reducer';

export const driverState = createFeatureSelector<DriverState>('driver');

export const getDriverSearchString = createSelector(driverState, (state: DriverState) => state.driverSearchString);

export const getDriverSearchPageNumber = createSelector(driverState, (state: DriverState) => state.driverSearchPageNumber);

export const getDriverSearchPageSize = createSelector(driverState, (state: DriverState) => state.driverSearchPageSize);

export const getDriverSearchResults = createSelector(driverState, (state: DriverState) => state.driverSearchResults);

export const getDriverSearchLoading = createSelector(driverState, (state: DriverState) => state.driverSearchLoading);

export const getDriver = createSelector(driverState, (state: DriverState) => state.driver);

export const getVehicles = createSelector(driverState, (state: DriverState) => state.vehicles);

export const getProfilePictureUrl = createSelector(driverState, (state: DriverState) => state.driverProfilePictureUrl);

export const getDriverBank = createSelector(driverState, (state: DriverState) => state.driverBank);

export const getExpandedScreening = createSelector(driverState, (state: DriverState) => state.expandedScreening);

export const getSubstanceScreening = createSelector(driverState, (state: DriverState) => state.substanceScreening);

export const getMVROrderDetails = createSelector(driverState, (state: DriverState) => state.mvrOrderDetails);

export const getDriverBankCreditTransactionReasons = createSelector(
  driverState,
  (state: DriverState) => state.driverBankTransactionCreditReasons
);

export const getDriverBankDebitTransactionReasons = createSelector(
  driverState,
  (state: DriverState) => state.driverBankTransactionDebitReasons
);

export const getCustomerServiceNotes = createSelector(driverState, (state: DriverState) => state.customerServiceNotes);

export const getBankTransactions = createSelector(driverState, (state: DriverState) =>
  state.bankTransactions && state.bankTransactions.length && state.bankTransactions.length > 0
    ? state.bankTransactions.sort((a, b) => +new Date(b.createdDate) - +new Date(a.createdDate))
    : state.bankTransactions
);

export const getBankTransactionsStartDate = createSelector(driverState, (state: DriverState) => state.bankTransactionsStartDate);

export const getBankTransactionsEndDate = createSelector(driverState, (state: DriverState) => state.bankTransactionsEndDate);

export const getBankTransactionsPageNumber = createSelector(driverState, (state: DriverState) => state.bankTransactionsPageNumber);

export const getBankTransactionsPageSize = createSelector(driverState, (state: DriverState) => state.bankTransactionsPageSize);

export const getDriverReservations = createSelector(driverState, (state: DriverState) => state.reservations);

export const getReservationsPageIndex = createSelector(driverState, (state: DriverState) => state.reservationsPageIndex);

export const getReservationsPageSize = createSelector(driverState, (state: DriverState) => state.reservationsPageSize);

export const getDriverScreenings = createSelector(driverState, (state: DriverState) => state.driverScreenings);

export const getDriverScreeningsPageIndex = createSelector(driverState, (state: DriverState) => state.driverScreeningsPageIndex);

export const getDriverScreeningsPageSize = createSelector(driverState, (state: DriverState) => state.driverScreeningsPageSize);

export const getDriverAddress = createSelector(driverState, (state: DriverState) => state.driverAddress);

export const getDriverSuspensions = createSelector(driverState, (state: DriverState) => state.driverSuspensions);

export const getLastSuspensionDate = createSelector(driverState, (state: DriverState) => state.lastSuspensionDate);

export const getDeactivationReasons = createSelector(driverState, (state: DriverState) => state.deactivationReasons);

export const getViewReferrer = createSelector(driverState, (state: DriverState) => state.viewReferrer);

export const getEditReferrer = createSelector(driverState, (state: DriverState) => state.editReferrer);

export const getReferrerSearchResults = createSelector(driverState, (state: DriverState) => state.referrerSearchResults);

export const getReferrer = createSelector(driverState, (state: DriverState) => state.referrer);

export const getSelectedReferrer = createSelector(driverState, (state: DriverState) => state.selectedReferrer);

export const getReferrerSearchPageSize = createSelector(driverState, (state: DriverState) => state.referrerSearchPageSize);

export const getRandomScreeningYearlyProgress = createSelector(driverState, (state: DriverState) => state.randomScreeningYearlyProgress);

export const getRandomScreeningDriverSelectionInfos = createSelector(
  driverState,
  (state: DriverState) => state.randomScreeningDriverSelectionInfos
);

export const getRandomScreeningDriverSelectionInfosPageIndex = createSelector(
  driverState,
  (state: DriverState) => state.randomScreeningDriverSelectionInfosPageIndex
);

export const getRandomScreeningDriverSelectionInfosPageSize = createSelector(
  driverState,
  (state: DriverState) => state.randomScreeningDriverSelectionInfosPageSize
);

export const getRandomScreeningDriverSelection = createSelector(driverState, (state: DriverState) => state.randomScreeningDriverSelection);

export const getRandomScreeningConfigurationValues = createSelector(
  driverState,
  (state: DriverState) => state.randomScreeningConfigurationValues
);

export const getRefusalReasons = createSelector(driverState, (state: DriverState) => state.refusalReasons);

export const getCurrentlyEditedRandomScreeningConfigurationValue = createSelector(driverState, (state: DriverState) => {
  return state.currentlyEditedRandomScreeningConfigurationValue;
});
export const getDriverAnnualRideExecutionData = createSelector(driverState, (state: DriverState) => state.driverAnnualRideExecutionData);

export const getLatestTaxYearRideExecutionData = createSelector(driverState, (state: DriverState) => {
  if (isNullOrUndefined(state.driverAnnualRideExecutionData)) {
    return null;
  }

  const latestTaxYear = new Date().getFullYear() - 1;

  return state.driverAnnualRideExecutionData.find(red => red.year === latestTaxYear);
});

export const getDriverTaxDocuments = createSelector(driverState, (state: DriverState) => state.driverTaxDocuments);
